import { Box } from "@mui/material"
import { TextField } from "react-admin"

const HeadingComponent = () => {
  return (
    <Box>
      <TextField source="textModel.heading" variant="h5" />
    </Box>
  )
}

export default HeadingComponent